import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {AccountHeadshotsPanel} from "../../common/headshots-panel/headshots-panel";
import {ProfileLayout}         from "../common/profile-layout";

export const AccountHeadshotsRoute = () => cs(
    ({}, next) => ProfileLayout({activeTab: "headshots", next}),
    () => AccountHeadshotsPanel({
    }),
);
